import Vue from 'vue';
import { SessionStorageKeys } from '@/modules/SessionStorage/sessionStorageKeys';

const vue = new Vue();

export const saveToSessionStorage = (key: SessionStorageKeys, value: string) =>
  vue.$session.set(key as string, value);
